import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import { Label, Input, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    getData() {
        const { nombre, obligatorio } = this.state;
        return {
            "nombre": nombre,
            "obligatorio": obligatorio
        }
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.config.plan.campos.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                onPreSubmit={() => this.getData()}
                successMessage={"El Campo del Plan de Trabajo ha sido creado con éxito."}
                title={"Nuevo Campo del Plan de Trabajo"}
                buttonTitle={"Nuevo Campo del Plan de Trabajo"}
                buttonIcon={"fa fa-plus fa-lg"}

                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del campo</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input onChange={(e) => this.setState({ nombre: e.target.value })} type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <label className="ui-checkbox-opt">
                                <input onChange={(e) => this.setState({ obligatorio: e.target.checked })} type="checkbox" name="obligatorio" />
                                <span>Obligatorio</span>
                            </label>
                            <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_Campos/Create.js